import { createSlice } from "@reduxjs/toolkit";
import * as moment from "moment";
import { USER_STATUS } from "../utils/constants";

const initialState = {
	registeredUsers: [],
	activeUsers: [],
	rejectedUsers: [],
	fetchingRegisteredUsers: false,
	fetchingRegisteredUsersComplete: false,
	fetchingRegisteredUsersError: null,

	isApprovingUser: false,
	approveUserError: null,

	isRejectingUser: false,
	rejectUserError: null,

	updatingUser: false,
	updateUserError: null,
};

const slice = createSlice({
	name: "@registrations",
	initialState,
	reducers: {
		fetchUsersBegin(state) {
			state.fetchingRegisteredUsers = true;
			state.fetchingRegisteredUsersError = null;
		},
		fetchUsersSuccess(state, action) {
			state.fetchingRegisteredUsers = false;
			const formattedData = formatRegisteredUsers(action.payload.data);
			state.fetchingRegisteredUsersComplete = true;
			state.registeredUsers = formattedData;
			state.activeUsers = formattedData.filter((data) => {
				return data.approvalStatus !== USER_STATUS.REJECTED;
			});
			state.rejectedUsers = formattedData.filter((data) => {
				return data.approvalStatus === USER_STATUS.REJECTED;
			});
			state.registerUserError = null;
		},
		fetchUsersFailure(state, action) {
			state.fetchingRegisteredUsers = false;
			state.registeredUsers = [];
			state.fetchingRegisteredUsersError = action.payload;
		},
		approveUserBegin(state) {
			state.isApprovingUser = true;
			state.approveUserError = null;
		},
		approveUserSuccess(state, action) {
			state.isApprovingUser = false;
			state.approveUserError = null;
		},
		approveUserFailure(state, action) {
			state.isApprovingUser = false;
			state.approveUserError = action.payload;
		},
		updateUserBegin(state) {
			state.updatingUser = true;
			state.updateUserError = null;
		},
		updateUserSuccess(state, action) {
			state.updatingUser = false;
			state.updateUserError = null;
		},
		updateUserFailure(state, action) {
			state.updatingUser = false;
			state.updateUserError = action.payload;
		},
	},
});

const formatRegisteredUsers = (data) => {
	data.map((user) => {
		const formattedDob = moment.unix(user.dob).format("DD/MM/YYYY");
		user["formattedDob"] = formattedDob;
		user["age"] = moment().diff(moment(formattedDob, "DD/MM/YYYY"), "years");

		return user;
	});

	data.sort((a, b) => {
		const approvalStatusA = a["approvalStatus"].toUpperCase();
		const approvalStatusB = b["approvalStatus"].toUpperCase();

		if (approvalStatusA < approvalStatusB) {
			return -1;
		}

		if (approvalStatusA > approvalStatusB) {
			return 1;
		}

		return 0;
	});

	return data;
};

export const {
	fetchUsersBegin,
	fetchUsersSuccess,
	fetchUsersFailure,
	approveUserBegin,
	approveUserSuccess,
	approveUserFailure,
	updateUserBegin,
	updateUserSuccess,
	updateUserFailure,
} = slice.actions;

export default slice.reducer;
